import React from 'react';
import '@roo/roo/theme/blue/index.css'; // 蓝色主题
import CheckBox from '@roo/roo/CheckBox';
import './index.scss';
import regionUtil from '@/utils/region';
// @ts-ignore
const CheckBoxGroup = CheckBox.Group;

// 可选输入参数默认值
const defaultProps = {
    disabledCity: [], // 禁止勾选项
    selectedCity: [], // 禁止勾选项
    bgStyle: 'white', // 背景颜色
    haveCheckAll: true, // 是否展示全选按钮，默认展示
    controlled: true,
    changeValue: () => {},
};

type IProps = {
    provinceList: urls.freight.IprovinceInfo[];
    selectedCity?: urls.freight.Icity[]; // 选中的城市
    disabledCity?: urls.freight.Icity[]; // 置灰的城市
    changeValue: (params: any) => void; // 向父组件动态传递已选中的city值
    haveCheckAll?: boolean;
    controlled?: boolean;
    ref?: any;
    defaultCheckedCity?: urls.freight.Icity[]; // 默认选中的城市，非受控用，非受控都是取state的数据
} & Partial<typeof defaultProps>;

interface IState {
    sSelectIds: number[];
    sDisabledIds: number[];
}

class Region extends React.Component<IProps, IState> {
    static defaultProps = defaultProps;

    allCities: Array<urls.freight.Icity> = [];

    constructor(props: IProps) {
        super(props);

        let sSelectIds: number[] = [];
        let sDisabledIds: number[] = [];
        if (!props.controlled) {
            if (props.defaultCheckedCity) {
                sSelectIds = props.defaultCheckedCity.map((city: any) => city.cityId);
            }
            if (props.disabledCity) {
                sDisabledIds = props.disabledCity.map((city: any) => city.cityId);
            }
        }

        this.state = {
            sSelectIds,
            sDisabledIds, // 如果是非受控，且有不可选的数据，默认勾选上
        };
    }

    // 点击选择某个城市
    handleGroupChange = (vals: any) => {
        const { props, state } = this;
        // 完全受控的，props来控制
        if (props.controlled) {
            const selectCities: any = regionUtil.getCityByIds(this.allCities, vals);
            props.changeValue(selectCities);
        } else {
            // 非受控的，state数据来保存，最后通过ref来拿到数据
            // 排除disable的数据
            const sSelectIds: any = [];
            vals.forEach((val: any) => {
                if (state.sDisabledIds.indexOf(val) === -1) {
                    sSelectIds.push(val);
                }
            });
            this.setState({
                sSelectIds,
            });
        }
    };

    getSelectedCities = () => {
        const { state } = this;
        return regionUtil.getCityByIds(this.allCities, state.sSelectIds);
    };

    // 设置所有的城市
    setAllCities = (provinceList: Array<urls.freight.IprovinceInfo>) => {
        const allCities: any = [];
        provinceList.forEach((item: any) => {
            item.cityList.forEach((city: any) => {
                allCities.push(city);
            });
        });
        this.allCities = allCities;
    };

    // 全选点击逻辑
    handleAllChecked = () => {
        const { props, state } = this;
        const { selectedCity = [], disabledCity = [] } = props;

        if (props.controlled) {
            if (selectedCity.length + disabledCity.length === this.allCities.length) {
                props.changeValue([]);
            } else {
                // 可用的城市，排除disable的城市
                const disableIds = this.getIds(disabledCity);
                const allValidCities: any = [];
                this.allCities.forEach(city => {
                    if (disableIds.indexOf(city.cityId) === -1) {
                        allValidCities.push(city);
                    }
                });
                props.changeValue(allValidCities);
            }
        } else {
            let sSelectIds: number[] = [];
            if (state.sSelectIds.length + state.sDisabledIds.length === this.allCities.length) {
                sSelectIds = [];
            } else {
                // 排除disabled的城市
                this.allCities.forEach((city: any) => {
                    if (state.sDisabledIds.indexOf(city.cityId) === -1) {
                        sSelectIds.push(city.cityId);
                    }
                });
            }
            this.setState({
                sSelectIds,
            });
        }
    };

    getIds = (cities: urls.freight.Icity[]) =>
        cities.map((city: urls.freight.Icity) => city.cityId);

    render() {
        const { props, state } = this;
        const {
            bgStyle,
            provinceList,
            selectedCity = [],
            disabledCity = [],
            haveCheckAll,
            controlled,
        } = props;
        if (this.allCities.length === 0) {
            this.setAllCities(provinceList);
        }
        const selectIds = this.getIds(selectedCity);
        const disableIds = this.getIds(disabledCity);
        if (!provinceList || provinceList.length === 0) {
            return <div>您已选择所有地区为包邮配送，暂无可选地区</div>;
        }
        return (
            <div className="content-wrapper" style={{ backgroundColor: bgStyle }}>
                {haveCheckAll ? (
                    <div className="flex-box">
                        <div className="flex-item1" />
                        <div className="checked">
                            <div className="select-all">
                                <CheckBox
                                    indeterminate={
                                        props.controlled
                                            ? selectIds.length !== 0
                                            : state.sSelectIds.length !== 0
                                    }
                                    checked={
                                        props.controlled
                                            ? selectIds.length + disableIds.length ===
                                              this.allCities.length
                                            : state.sSelectIds.length === this.allCities.length
                                    }
                                    onChange={this.handleAllChecked}
                                >
                                    全选
                                </CheckBox>
                            </div>
                            <div style={{ display: 'inline-block', fontWeight: 500 }}>
                                已选
                                <div
                                    style={{
                                        color: '#00abe4',
                                        display: 'inline-block',
                                        padding: '4px',
                                    }}
                                >
                                    {props.controlled ? selectIds.length : state.sSelectIds.length}
                                </div>
                                个区域
                            </div>
                        </div>
                    </div>
                ) : null}
                <CheckBoxGroup
                    value={controlled ? selectIds : state.sSelectIds.concat(state.sDisabledIds)}
                    onChange={this.handleGroupChange}
                >
                    {provinceList.map(group => {
                        const key = group.groupName;
                        // 按照分组groupName展示各个复选框
                        return (
                            <div className="flex-box" key={key}>
                                <div className="flex-item1">{group.groupName}</div>
                                <div className="flex-item2">
                                    {group.cityList.map(({ cityId, cityName }) => (
                                        <CheckBox
                                            key={cityId}
                                            value={cityId}
                                            disabled={disableIds.indexOf(cityId) !== -1}
                                        >
                                            {cityName}
                                        </CheckBox>
                                    ))}
                                </div>
                            </div>
                        );
                    })}
                </CheckBoxGroup>
            </div>
        );
    }
}

export default Region;
